import { useAtom } from 'jotai';
import { persistedOverviewAtom } from '../atoms';
import { useFrustrationSignalList } from '@src/hooks/frustrationSignal/useFrustrationSignalConfigs';
import { useEffect } from 'react';

/**
 * Hook to access and initialize frustration signal data from atoms
 */
function useFrustrationSignalOverview() {
  const [{ frustrationSignals }, setPersistedOverview] = useAtom(persistedOverviewAtom);
  const availableSignalIds = useFrustrationSignalList();

  // Initialize frustration signals with all available signals if empty
  useEffect(() => {
    if (
      availableSignalIds.length > 0 &&
      (!frustrationSignals || Object.keys(frustrationSignals).length === 0)
    ) {
      const formattedSignals = {};
      availableSignalIds.forEach((signalId, index) => {
        formattedSignals[signalId] = {
          id: signalId,
          order: index + 1,
        };
      });

      setPersistedOverview((prev) => ({
        ...prev,
        frustrationSignals: formattedSignals,
      }));
    }
  }, [availableSignalIds, frustrationSignals, setPersistedOverview]);

  // Get ordered signal IDs from the frustrationSignals object
  const orderedSignalIds = frustrationSignals
    ? Object.entries(frustrationSignals)
        .sort(([, a], [, b]) => a.order - b.order)
        .map(([id]) => id)
    : [];

  return {
    name: 'overview-frustration-signal-store',
    frustrationSignals: orderedSignalIds,
    frustrationSignalsData: frustrationSignals || {},
  };
}

export default useFrustrationSignalOverview;
